import { render, staticRenderFns } from "./ShopOrderDetail.vue?vue&type=template&id=2c00491d&scoped=true"
import script from "./ShopOrderDetail.vue?vue&type=script&lang=js"
export * from "./ShopOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./ShopOrderDetail.vue?vue&type=style&index=0&id=2c00491d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00491d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c00491d')) {
      api.createRecord('2c00491d', component.options)
    } else {
      api.reload('2c00491d', component.options)
    }
    module.hot.accept("./ShopOrderDetail.vue?vue&type=template&id=2c00491d&scoped=true", function () {
      api.rerender('2c00491d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryEffiRider/ShopOrderDetail.vue"
export default component.exports